import React from 'react';
import { getEnvVar } from '@shoflo/polymer/utils/getEnvVar';

if (getEnvVar('REACT_APP_WDYR') === 'true') {
  const whyDidYouRender = require('@welldone-software/why-did-you-render');
  whyDidYouRender(React, {
    // trackAllPureComponents: true,
  });
}
